import type { MomentCoupon } from "../../data/momentOptions";
import ButtonsRow from "./ButtonsRow";
import CouponPreview from "./CouponPreview";
import FooterBar from "./FooterBar";

type Props = {
  body: string;
  messageTitle: string;
  imagePreview: string | null;
  displayButtons: { id: string; title: string }[];
  shareFlag: boolean;
  couponEnabled: boolean;
  coupon: MomentCoupon;
};

export default function WideMessagePreview({
  body, messageTitle, imagePreview, displayButtons, shareFlag, couponEnabled, coupon,
}: Props) {
  const previewBody = body.trim() || "내용을 입력해주세요";

  return (
    <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-overflow-hidden tw-text-[13px] tw-leading-relaxed">
      <div className="tw-w-full tw-h-40 tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-text-gray-400">
        {imagePreview ? (
          <img src={imagePreview} alt="미리보기" className="tw-w-full tw-h-full tw-object-cover" />
        ) : (
          "이미지"
        )}
      </div>
      <div className="tw-px-4 tw-pt-3 tw-pb-2 tw-break-all">
        {messageTitle.trim() && (
          <strong className="tw-block tw-text-[13px] tw-font-bold tw-text-gray-900 tw-mb-1 tw-whitespace-pre-line">
            {messageTitle}
          </strong>
        )}
        <p className="tw-whitespace-pre-line tw-text-gray-800 tw-text-[13px]">{previewBody}</p>
      </div>
      {(displayButtons.length > 0 || shareFlag) && (
        <ButtonsRow buttons={displayButtons} shareFlag={shareFlag} />
      )}
      <CouponPreview couponEnabled={couponEnabled} coupon={coupon} />
      <FooterBar />
    </div>
  );
}
